(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.collection-sort select').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floor-explorer"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.floor-explorer').forEach((root) => {
      const tabs = root.querySelectorAll('.floor-tab');
      const panels = root.querySelectorAll('.floor-panel');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const i = tab.dataset.floor;
          tabs.forEach((t) => {
            const on = t.dataset.floor === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach((p) => p.classList.toggle('is-active', p.dataset.floor === i));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slider = document.querySelector('[data-hero-reveal]');
    if (!slider) return;

    // Constrain --split to [0.02, 0.98] so both states stay visible at extremes.
    const update = (clientX) => {
      const rect = slider.getBoundingClientRect();
      const split = Math.max(0.02, Math.min(0.98, (clientX - rect.left) / rect.width));
      slider.style.setProperty('--split', split.toFixed(4));
    };

    let dragging = false;
    slider.addEventListener('pointerdown', (e) => {
      dragging = true;
      slider.setPointerCapture(e.pointerId);
      slider.classList.add('is-interacting');
      slider.classList.remove('is-demo'); // user takes over → stop the intro
      update(e.clientX);
      e.preventDefault();
    });
    slider.addEventListener('pointermove', (e) => { if (dragging) update(e.clientX); });
    const endDrag = (e) => {
      if (!dragging) return;
      dragging = false;
      if (slider.hasPointerCapture(e.pointerId)) slider.releasePointerCapture(e.pointerId);
      slider.classList.remove('is-interacting');
    };
    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);

    // Intro morph once per session; reduced-motion / return visits skip to rest.
    const SESSION_KEY = 'soarbrick-hero-demo-played';
    const REST_SPLIT = '0.1';
    const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let played = false;
    try { played = sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) {}

    if (!prefersReduced && !played) {
      slider.classList.add('is-demo');
      slider.addEventListener('animationend', () => {
        // Snapshot rest split before dropping .is-demo so it doesn't jump.
        slider.style.setProperty('--split', REST_SPLIT);
        slider.classList.remove('is-demo');
        try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
      }, { once: true });
    } else {
      slider.style.setProperty('--split', REST_SPLIT);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    // Hero gallery: cycle the full-bleed image via dots / prev-next arrows.
    const heroImg = document.getElementById('ProductHeroImage');
    const dots = Array.from(document.querySelectorAll('.product-hero-dot'));
    const prev = document.querySelector('.product-hero-prev');
    const next = document.querySelector('.product-hero-next');
    let idx = 0;

    function show(i) {
      if (!dots.length) return;
      idx = (i + dots.length) % dots.length;
      const url = dots[idx].dataset.full;
      if (heroImg && url) {
        heroImg.removeAttribute('srcset');
        heroImg.src = url;
      }
      dots.forEach((d, n) => d.classList.toggle('is-active', n === idx));
    }
    dots.forEach((d, n) => d.addEventListener('click', () => show(n)));
    if (prev) prev.addEventListener('click', () => show(idx - 1));
    if (next) next.addEventListener('click', () => show(idx + 1));

    // Sticky buy bar: show once the hero buy panel scrolls out of view.
    const buy = document.getElementById('ProductBuy');
    const sticky = document.getElementById('StickyBuy');
    if (buy && sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        },
        { rootMargin: '-80px 0px 0px 0px' }
      );
      io.observe(buy);
    }

    // Image lightbox: any [data-zoom] opens the <dialog> with an enlarged view.
    const lightbox = document.querySelector('[data-lightbox]');
    if (lightbox && typeof lightbox.showModal === 'function') {
      const lbImg = lightbox.querySelector('[data-lightbox-img]');
      const lbCap = lightbox.querySelector('[data-lightbox-caption]');
      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-zoom]');
        if (!t) return;
        lbImg.src = t.dataset.full || t.currentSrc || t.src;
        lbImg.alt = t.alt || '';
        if (lbCap) lbCap.textContent = t.dataset.caption || '';
        lightbox.showModal();
      });
      lightbox.querySelectorAll('[data-lightbox-close]').forEach((b) =>
        b.addEventListener('click', () => lightbox.close())
      );
      // Click on the backdrop (outside the image) closes.
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox) lightbox.close(); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
